export default __webpack_public_path__ + "images/onboarding/divide-164f0f7d7f7865ce2a6d1a843841e076.svg";